import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCartItems,
  selectCartTotal,
  clearCart,
} from "../../ReduxCart/Cart/cartSlice";
import "./CheckoutPlansCSS.css";
import LegalBradcrumeSection from "../Community/LegalBradcrumeSection";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import CheckoutEnquiryValidation from "./CheckoutEnquiryValidation";
import APIDataFetchLoader from "../Others/APIDataFetchLoader";
// import { formatPrice } from "../Others/ImportantFunction";
import { useAuth } from "../../Store/AuthContext";
import { Helmet } from "react-helmet";
import getepayPortal from "./Getepay_pg_node/index";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function CheckoutPlansdemo() {
  const dispatch = useDispatch();
  const { userID, userRoll, RendomTokenfetch, profileData } = useAuth();
  const navigate = useNavigate();

  // Get cart data from Redux store
  const cartItems = useSelector(selectCartItems);
  const cartTotal = useSelector(selectCartTotal);
  // const FormattedTotalPrice = formatPrice(cartTotal);

  const nameref = useRef(profileData?.username || "");
  const emailref = useRef(profileData?.email || "");
  const [description, setdescriptions] = useState("");
  const addreshref = useRef(profileData?.address || "");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formValiderror, setformValiderror] = useState({});
  const [selectedPayment, setSelectedPayment] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  useEffect(() => {
    if (profileData?.number) {
      setMobileNumber(profileData.number);
    }
  }, [profileData]);

  // Fetch States
  useEffect(() => {
    setLoading(true);
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllState`, {
            params: { country_id: "101" },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setStates(response.data.allstateData || []);
              setCities([]);
            } else {
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchSubServiceStateData();
  }, [RendomTokenfetch]);

  // Fetch cities when state changes
  useEffect(() => {
    setLoading(true);
    const FetchServiceCityData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllCity`, {
            params: { state_id: selectedState },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setCities(response.data.allcityData || []);
            }
            if (response.data.Status === "0") {
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchServiceCityData();
  }, [RendomTokenfetch, selectedState]);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handlePaymentMethod = (event) => {
    setSelectedPayment(event.target.value);
    setformValiderror({});
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsProcessingPayment(true);

    if (cartItems.length === 0) {
      NotifyMessageNoReload("Your cart is empty", "danger", true);
      setIsProcessingPayment(false);
      return;
    }

    if (!selectedPayment) {
      NotifyMessageNoReload("Please select a payment method", "danger", true);
      setIsProcessingPayment(false);
      return;
    }

    try {
      // Prepare order data
      // const orderData = {
      //   userid: userID,
      //   userroll: userRoll,
      //   items: cartItems.map((item) => ({
      //     planid: item.planid,
      //     quantity: item.quantity,
      //     price: item.selling_price,
      //   })),
      //   customer_details: {
      //     name: nameref.current?.value || "",
      //     email: emailref.current?.value || "",
      //     mobile: mobileNumber,
      //     address: addreshref.current?.value || "",
      //     state: selectedState,
      //     city: selectedcity,
      //     notes: description,
      //   },
      //   payment_method: selectedPayment,
      //   total_amount: cartTotal,
      // };

      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("userroll", userRoll);
      fdata.append("planid", "2");
      fdata.append("name", nameref.current?.value || "");
      fdata.append("email", emailref.current?.value || "");
      fdata.append("number", mobileNumber);
      fdata.append("state", selectedState);
      fdata.append("city", selectedcity);
      fdata.append("address", addreshref.current?.value || "");
      fdata.append("description", description);
      fdata.append("payment_method", selectedPayment);
      fdata.append("total_amount", cartTotal);

      axios
        .post(`${WebsiteAPIurl}leadAdd`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (
            nameref.current?.value &&
            mobileNumber &&
            emailref.current.value &&
            selectedPayment
          ) {
            if (response.data.Status === "1") {
              const orderId = response.data.order_id;

              if (selectedPayment === "1") {
                // Online payment
                // Prepare payment gateway data
                const paymentData = {
                  mid: 108, // Your merchant ID
                  amount: cartTotal,
                  merchantTransactionId: `ORD${orderId}_${Date.now()}`,
                  transactionDate: new Date().toISOString(),
                  terminalId: "Getepay.merchant61062@icici",
                  udf1: mobileNumber,
                  udf2: emailref.current?.value || "",
                  udf3: "Service Purchase",
                  ru: "https://pay1.getepay.in:8443/getepayPortal/pg/pgPaymentResponse",
                  callbackUrl: "",
                  // ru: `${window.location.origin}/payment-callback`, // Return URL
                  // callbackUrl: `${WebsiteAPIurl}paymentCallback`, // Callback URL
                  currency: "INR",
                  paymentMode: "ALL",
                  txnType: "single",
                  productType: "IPG",
                  txnNote: `Payment for order ${orderId}`,
                  vpa: "Getepay.merchant61062@icici",
                  orderId: orderId,
                };

                // Payment gateway config
                const config = {
                  GetepayMid: 108,
                  GeepayTerminalId: "Getepay.merchant61062@icici",
                  GetepayKey: "JoYPd+qso9s7T+Ebj8pi4Wl8i+AHLv+5UNJxA3JkDgY=",
                  GetepayIV: "hlnuyA9b4YxDq6oJSZFl8g==",
                  GetepayUrl:
                    "https://pay1.getepay.in:8443/getepayPortal/pg/generateInvoice",
                };

                // Initiate payment
                getepayPortal(paymentData, config, (paymentResponse) => {
                  if (paymentResponse.status === "success") {
                    NotifyMessageNoReload(
                      "Payment initiated successfully",
                      "success",
                      true
                    );
                    // Handle successful payment initiation
                  } else {
                    NotifyMessageNoReload(
                      "Payment initiation failed",
                      "danger",
                      true
                    );
                    setIsProcessingPayment(false);
                  }
                });
              } else {
                // Pay later
                NotifyMessageNoReload(
                  "Order placed successfully",
                  "success",
                  true
                );
                dispatch(clearCart());
                navigate("/order-confirmation", { state: { orderId } });
              }
            } else {
              NotifyMessageNoReload(
                response.data.msg || "Order creation failed",
                "danger",
                true
              );
              setformValiderror(
                CheckoutEnquiryValidation(response.data.errors || {})
              );
            }
          } else {
            NotifyMessageNoReload(response.data.msg, "danger", true);
            setformValiderror(
              CheckoutEnquiryValidation(response.data?.form_validation || {})
            );
          }
        });
    } catch (error) {
      console.error("Checkout error:", error);
      NotifyMessageNoReload(
        "An error occurred during checkout",
        "danger",
        true
      );
    } finally {
      setIsProcessingPayment(false);
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }

  if (error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">Error: {error}</div>
        <button
          className="btn btn-primary mt-3"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (cartItems.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h3>Your cart is empty</h3>
        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate("/services")}
        >
          Browse Services
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        {/* <title>Checkout - Your Order</title>
        <meta name="description" content="Complete your service booking" />
        <link rel="canonical" href={window.location.href} /> */}
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>

      <LegalBradcrumeSection
        Pagename={"Checkout"}
        page1={[
          { name: "Services", pagelink: "services" },
          { name: "Cart", pagelink: "cart" },
          { name: "Checkout" },
        ]}
      />

      <section className="shop-single serviceChecket">
        <div className="auto-container">
          <div className="product-details mb-0">
            <div className="basic-details mb-0">
              <form
                className="was-validated checkoutForm default-form defaultForm"
                onSubmit={handleSubmit}
              >
                <div className="row clearfix">
                  <div className="image-column col-md-8 col-sm-12 mb-0">
                    <h5 className="mb-3 fw-700">Booking Details</h5>

                    <div className="row">
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label className="form-label" htmlFor="name">
                          Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          ref={nameref}
                          defaultValue={profileData?.username || ""}
                          className="form-control"
                          required
                        />
                        {formValiderror.name && (
                          <span className="text-danger">
                            * {formValiderror.name}
                          </span>
                        )}
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          ref={emailref}
                          defaultValue={profileData?.email || ""}
                          className="form-control"
                          required
                        />
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label>Mobile Number</label>
                        <div className="input-group">
                          <span className="input-group-text">91</span>
                          <input
                            type="text"
                            className="form-control w-50"
                            name="mobileNumber"
                            onChange={handleMobileChange}
                            onKeyPress={handleKeyPress}
                            value={mobileNumber}
                            maxLength={10}
                            inputMode="numeric"
                            required
                          />
                        </div>
                        {formValiderror.number && (
                          <span className="text-danger">
                            * {formValiderror.number}
                          </span>
                        )}
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label>State</label>
                        <select
                          className="form-control"
                          value={selectedState}
                          onChange={(e) => setSelectedState(e.target.value)}
                          required
                        >
                          <option value="">Select State</option>
                          {states.map((state, index) => (
                            <option value={state.id} key={index}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                        <label>City</label>
                        <select
                          className="form-control"
                          value={selectedcity}
                          onChange={(e) => setSelectedcity(e.target.value)}
                          disabled={!cities.length}
                          required
                        >
                          <option value="">Select City</option>
                          {cities.map((city, index) => (
                            <option value={city.id} key={index}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-lg-12 col-md-12 mb-3">
                        <label>Address</label>
                        <textarea
                          className="form-control"
                          placeholder=""
                          rows={2}
                          ref={addreshref}
                          defaultValue={profileData?.address || ""}
                          required
                        ></textarea>
                      </div>

                      <div className="form-group col-lg-12 col-md-12 mb-3">
                        <label>Additional Notes</label>
                        <textarea
                          value={description}
                          onChange={(e) => setdescriptions(e.target.value)}
                          rows={4}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="info-column col-md-4 col-sm-12 cheoutDeatls mb-0">
                    <div className="order-box">
                      <h3 className="checketheading">Your Order</h3>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Service</th>
                            <th>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {item.title} × {item.quantity}
                              </td>
                              <td>
                                ₹
                                {(item.selling_price * item.quantity).toFixed(
                                  2
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr className="serviceordertotal">
                            <td>Total</td>
                            <td>
                              <span className="amount">
                                ₹{cartTotal.toFixed(2)}
                              </span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>

                      <div className="payment-methods mt-4">
                        <h5>Payment Methods</h5>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="paymentmethod"
                            id="onlinePayment"
                            value="1"
                            onChange={handlePaymentMethod}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="onlinePayment"
                          >
                            Online Payment
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="paymentmethod"
                            id="payLater"
                            value="0"
                            onChange={handlePaymentMethod}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="payLater"
                          >
                            Pay Later
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12 text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block mt-3 w-100"
                          disabled={isProcessingPayment}
                        >
                          {isProcessingPayment ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Processing...
                            </>
                          ) : (
                            "Place Order"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
